import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { BoosterTypeEnum, GameModel } from '../../Models/GameModel';
import { GameLogic } from '../../Logic/GameLogic';
import { BoosterListItemController, IBoosterListItemControllerOptions } from './BoosterListItemController';
import { DevConfig } from '../../Common/DevConfig';

export class BoosterListController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: any,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('BoosterListController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
                btn_needle: {
                    instanceName: 'btn_line',
                    controller: BoosterListItemController,
                    model: this.$model,
                    options: <IBoosterListItemControllerOptions>{
                        type: BoosterTypeEnum.needle,
                    },
                },
                btn_ball: {
                    instanceName: 'btn_brush',
                    controller: BoosterListItemController,
                    model: this.$model,
                    options: <IBoosterListItemControllerOptions>{
                        type: BoosterTypeEnum.yarn,
                    },
                },
                btn_bucket: {
                    instanceName: 'btn_bucket',
                    controller: BoosterListItemController,
                    model: this.$model,
                    options: <IBoosterListItemControllerOptions>{
                        type: BoosterTypeEnum.bucket,
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        if (DevConfig.HIDE_HOOK_BOOSTER) {
            const controller = this.$childControllers.get('btn_hook');
            if (controller) {
                controller.visible = false;
            }
        }
    }

    protected onResize(width: number, height: number, scale: number) {
    }
}
